import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import PDFReceiptInfoDialog from "./ReceiptDialogComponent";
import Button from "@mui/material/Button";
import { generateImmigrationBillPDF } from "../utility/services/immigration-bill";
import { generateImmigrationReceiptPDF } from "../utility/services/immigration-receipt";
import PDFBillInfoDialog from "./DialogComponent";
import { applicationManagement } from "../utility/services/apiService";
import { getAppId, getEmail } from "../utility/Common";
import { messages } from "../utility/services/message";
import { createNotification } from "./Popup";
import Header from "./layout/Header";
import NavBar_appID from "./layout/NavBar_appID";
import Footer from "./layout/Footer";

function BillInformations() {
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openReceipt, setOpenReceipt] = useState(false);
  const [base64, setBase64] = useState();

  const [bill, setBill] = useState([]);
  const [isReceiptLoading, setIsReceiptLoading] = useState(false);
  const [isBillLoading, setIsBillLoading] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setOpenReceipt(false);
  };

  function openPDFBillINfo(row) {
    if (row) {
      generateImmigrationBillPDF(row)
        .then((base64Pdf) => {
          setBase64(base64Pdf);
          setOpen(true);
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
        });
    }
  }

  useEffect(() => {
    getBillInfo();
  }, []);

  const getBillPdf = (item) => {
    setIsBillLoading(true);
    const payload = {
      ApplicationId: item?.PayerID,
      EmailAddress: item?.PyrEmail,
    };
    applicationManagement(payload, "check_bill")
      .then((result) => {
        setIsBillLoading(false);
        if (result.code === 1 && result.data) {
          if (result?.data.length > 0) {
            setBill(result.data);
            openPDFBillINfo(result.data[0]);
          } else {
            setBill([]);
          }
        } else if (result.code === 3) {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/continue");
        } else {
          const info = { type: "error", message: result?.message };
          createNotification(info)();
        }
      })
      .catch((error) => {
        setIsBillLoading(false);
        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      });
  };

  const getBillInfo = () => {
    const payload = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
    };
    applicationManagement(payload, "check_bill")
      .then((result) => {
        if (result?.data.length > 0) {
          setBill(result.data);
        } else {
          setBill([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function openPDFReceiptInfo(item) {
    setIsReceiptLoading(true);
    const payload = {
      ApplicationId: item?.PayerID,
      EmailAddress: item?.PyrEmail,
    };
    applicationManagement(payload, "check_payment")
      .then((result) => {
        setIsReceiptLoading(false);
        if (result.code === 1 && result.data) {
          if (result?.data.length >= 0) {
            generateImmigrationReceiptPDF(result.data[0])
              .then((base64Pdf) => {
                setBase64(base64Pdf);
                setOpenReceipt(true);
              })
              .catch((error) => {
                setIsReceiptLoading(false);
                console.error("Error generating PDF:", error);
              });
          } else {
            setBill([]);
          }
        } else if (result.code === 3) {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/continue");
        } else {
          const info = { type: "error", message: result?.message };
          createNotification(info)();
        }
      })
      .catch((error) => {
        setIsReceiptLoading(false);
        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      });
  }

  const endeleaBadae = () => {
    navigate("/");
    sessionStorage.clear();
    localStorage.clear();
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link to="#" className="list-group-item done">
                    Habari Binafsi{" "}
                  </Link>
                  <Link to="#" className="list-group-item done">
                    Anuwani ya Makazi
                  </Link>
                  <Link to="#" className="list-group-item done">
                    Habari za Wazazi{" "}
                  </Link>
                  <Link to="#" className="list-group-item done">
                    Habari za Safari
                  </Link>
                  <Link to="#" className="list-group-item done">
                    Wakati wa Dharura
                  </Link>
                  <Link to="#" className="list-group-item done">
                    Viambatanisho{" "}
                  </Link>
                  <Link className="list-group-item done">Tamko Rasmi </Link>
                  <Link to="/stp10" className="list-group-item done">
                    Hali ya Ombi{" "}
                  </Link>
                  <Link className="list-group-item active">Bili & Malipo</Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "16px" }}
              >
                <div className="tab-registration-content active">
                  <div className="box box-default">
                    <div className="col-lg-4">
                      <div className="form-group">
                        <br />
                        <span
                          className="field-validation-valid text-danger"
                          data-valmsg-htmlFor="Photo"
                          data-valmsg-replace="true"
                        ></span>
                      </div>
                    </div>
                    <br />

                    <table className="table table-striped custab">
                      <thead>
                        <tr>
                          <th style={{ width: "30%" }}>Jina Kamili</th>
                          <th style={{ width: "25%" }}>Nambari ya Malipo</th>
                          <th style={{ width: "20%" }}>Kiasi</th>
                          <th style={{ width: "*" }}>Kitendo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bill &&
                          bill.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.FullName}</td>
                              <td>{item?.ControlNo}</td>
                              <td>
                                {item?.Amount} {item?.Currency}
                              </td>

                              <td>
                                <Button
                                  type="button"
                                  onClick={() => getBillPdf(item)}
                                  className="showModalButton btn icon-btn btn-default"
                                  style={{ background: "#529ea9" }}
                                >
                                  <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                  <b style={{ color: "white" }}>
                                    {" "}
                                    {isBillLoading
                                      ? "Subiri.."
                                      : "Angalia Bili"}
                                  </b>
                                </Button>

                                <PDFReceiptInfoDialog
                                  open={openReceipt}
                                  onClose={handleClose}
                                  row={base64}
                                />

                                <PDFBillInfoDialog
                                  open={open}
                                  onClose={handleClose}
                                  row={base64}
                                />

                                <Button
                                  type="button"
                                  onClick={() => openPDFReceiptInfo(item)}
                                  className="showModalButton btn icon-btn btn-default"
                                  style={{
                                    background: "#529ea9",
                                    marginLeft: "5px",
                                  }}
                                >
                                  <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                  <b style={{ color: "white" }}>
                                    {isReceiptLoading
                                      ? "Subiri.."
                                      : "Angalia Risiti"}
                                  </b>
                                </Button>

                                <PDFReceiptInfoDialog
                                  open={openReceipt}
                                  onClose={handleClose}
                                  row={base64}
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="box-footer">
                    <div className="row">
                      <div className="col-md-4">
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            endeleaBadae();
                          }}
                          className="btn btn-default btn-block btn-label-next"
                        >
                          <i className="fa fa-angle-double-left"></i> | Hatua
                          Iliyotangulia
                        </Link>
                      </div>
                      <div className="col-md-4">
                        <Link
                          className="btn btn-labeled btn-block btn-default"
                          name="SaveExit"
                          onClick={(e) => {
                            e.preventDefault();
                            endeleaBadae();
                          }}
                        >
                          Endelea Baadae | <i className="fa fa-save"></i>{" "}
                        </Link>
                      </div>
                      <div className="col-md-4">
                        <button
                          type="submit"
                          className="btn btn-default btn-block btn-label-next"
                          name="SaveNext"
                          value="SaveContinue"
                          onClick={endeleaBadae}
                        >
                          Toka |<i className="fa fa-angle-double-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
export default BillInformations;
